// Debug methods for YourDetails component to track emitsOptions errors

export const debugMethods = {
  loadCartData() {
    console.log('🔍 DEBUG: loadCartData called');
    try {
      const { EncryptStorage } = require("encrypt-storage");
      const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
        storageType: "sessionStorage",
      });

      this.cartitem = encryptStorage.getItem("cart") || {};
      this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart") || {};
      this.lounge_cartitem = encryptStorage.getItem("lounge_cart") || {};
      this.cartloaded = true;
      
      console.log('🔍 DEBUG: Cart data loaded successfully');
    } catch (error) {
      console.error('🚨 ERROR in loadCartData:', error);
      if (error.message?.includes('emitsOptions')) {
        console.error('🚨 EMITS ERROR in loadCartData');
      }
    }
  },

  loadMarketingConfig() {
    console.log('🔍 DEBUG: loadMarketingConfig called');
    try {
      const brandMarketing = require("@/brand/brand.marketing.js").default;
      this.marketingConfig = brandMarketing[this.setbrandid] || brandMarketing.DEFAULT;
      console.log('🔍 DEBUG: Marketing config loaded:', this.marketingConfig);
    } catch (error) {
      console.error('🚨 ERROR in loadMarketingConfig:', error);
      if (error.message?.includes('emitsOptions')) {
        console.error('🚨 EMITS ERROR in loadMarketingConfig');
      }
    }
  },

  loadFasttrackPassengers() {
    console.log('🔍 DEBUG: loadFasttrackPassengers called');
    try {
      if (this.fasttrack_cartitem && Array.isArray(this.fasttrack_cartitem)) {
        this.fasttrack_cartitem.forEach((item) => {
          for (let i = 0; i < item.adult_count; i++) {
            this.fasttrack_passengers_ADL.push({
              title: "",
              firstname: "",
              surname: "",
            });
          }
          for (let i = 0; i < item.child_count; i++) {
            this.fasttrack_passengers_CHD.push({
              title: "",
              firstname: "",
              surname: "",
            });
          }
          for (let i = 0; i < item.infant_count; i++) {
            this.fasttrack_passengers_INF.push({
              title: "",
              firstname: "",
              surname: "",
            });
          }
        });
      }
      console.log('🔍 DEBUG: Fasttrack passengers loaded');
    } catch (error) {
      console.error('🚨 ERROR in loadFasttrackPassengers:', error);
      if (error.message?.includes('emitsOptions')) {
        console.error('🚨 EMITS ERROR in loadFasttrackPassengers');
      }
    }
  },

  setPlace(place) {
    console.log('🔍 DEBUG: setPlace called with:', place);
    try {
      if (place && place.formatted_address) {
        const addressComponents = place.address_components || [];
        
        addressComponents.forEach(component => {
          const types = component.types;
          if (types.includes('postal_code')) {
            this.postcode = component.long_name;
          }
          if (types.includes('locality')) {
            this.town = component.long_name;
          }
          if (types.includes('administrative_area_level_1')) {
            this.state = component.short_name;
          }
          if (types.includes('route')) {
            this.address = component.long_name;
          }
        });
        
        this.showaddressfields = true;
        console.log('🔍 DEBUG: Address fields populated from Google');
      }
    } catch (error) {
      console.error('🚨 ERROR in setPlace:', error);
      if (error.message?.includes('emitsOptions')) {
        console.error('🚨 EMITS ERROR in setPlace');
      }
    }
  },

  handleRememberDevice() {
    console.log('🔍 DEBUG: handleRememberDevice called');
    try {
      if (this.remember_device) {
        const deviceId = this.genHash(this.emailid);
        localStorage.setItem('remember_device_' + this.setbrandid, deviceId);
        console.log('🔍 DEBUG: Device remembered');
      } else {
        localStorage.removeItem('remember_device_' + this.setbrandid);
        console.log('🔍 DEBUG: Device forgotten');
      }
    } catch (error) {
      console.error('🚨 ERROR in handleRememberDevice:', error);
      if (error.message?.includes('emitsOptions')) {
        console.error('🚨 EMITS ERROR in handleRememberDevice');
      }
    }
  },

  genHash(string) {
    console.log('🔍 DEBUG: genHash called');
    try {
      const crypto = require('crypto');
      return crypto.createHash('md5').update(string).digest('hex');
    } catch (error) {
      console.error('🚨 ERROR in genHash:', error);
      return Date.now().toString();
    }
  },

  getLocalData(key) {
    console.log('🔍 DEBUG: getLocalData called for key:', key);
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      console.error('🚨 ERROR in getLocalData:', error);
      return null;
    }
  },

  setLocalData(key, value) {
    console.log('🔍 DEBUG: setLocalData called for key:', key);
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      console.error('🚨 ERROR in setLocalData:', error);
    }
  },

  getSessionData(key) {
    console.log('🔍 DEBUG: getSessionData called for key:', key);
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      console.error('🚨 ERROR in getSessionData:', error);
      return null;
    }
  },

  setSessionData(key, value) {
    console.log('🔍 DEBUG: setSessionData called for key:', key);
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      console.error('🚨 ERROR in setSessionData:', error);
    }
  },

  resetpromocode() {
    console.log('🔍 DEBUG: resetpromocode called');
    try {
      const { EncryptStorage } = require("encrypt-storage");
      const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
        storageType: "sessionStorage",
      });
      
      encryptStorage.removeItem("cart");
      encryptStorage.removeItem("fasttrack_cart");
      encryptStorage.removeItem("lounge_cart");
      window.location.href = "/";
    } catch (error) {
      console.error('🚨 ERROR in resetpromocode:', error);
    }
  }
};